import React from 'react';
import { View, StyleSheet } from 'react-native';

import AppStyles from '../AppStyles';
import { useFeature } from '../hooks';
import CustomText from './CustomText';
import { useTranslation } from '../i18n';

/**
 * FeatureToggleDemo - demonstration banner gated by the 'test-feature' toggle.
 *
 * Renders a confirmation message only when 'test-feature' is enabled for the user's
 * active organization. Used to demo the per-org feature toggle system; renders nothing
 * when the feature is off.
 */
export default function FeatureToggleDemo({ width }) {
  const { t } = useTranslation('support');

  const enabled = useFeature('test-feature');

  if (!enabled) return null;

  return (
    <View
      style={[styles.banner, width ? { width } : null]}
      accessibilityRole="alert"
      accessibilityLabel={t('support:featureToggleDemo')}
    >
      <CustomText font="semiBold" size={15} color={AppStyles.colorSet.textPrimary}>
        {`✅ ${t('support:featureToggleDemo')}`}
      </CustomText>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    backgroundColor: AppStyles.colorSet.brandPrimaryLight,
    borderWidth: 1,
    borderColor: AppStyles.colorSet.brandPrimary,
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 12,
    alignItems: 'center',
  },
});
